// src/@types/components/common/Dropdown.types.ts
var KitchenFontOption = /* @__PURE__ */ ((KitchenFontOption2) => {
  KitchenFontOption2["A11"] = "a11";
  KitchenFontOption2["B11"] = "b11";
  KitchenFontOption2["A12"] = "a12";
  KitchenFontOption2["B12"] = "b12";
  KitchenFontOption2["A21"] = "a21";
  KitchenFontOption2["B21"] = "b21";
  KitchenFontOption2["A22"] = "a22";
  KitchenFontOption2["B22"] = "b22";
  return KitchenFontOption2;
})(KitchenFontOption || {});

export { KitchenFontOption };
